import Language from "orbiter-core/src/datastructures/languages/Language";
import MultiLanguageString from "orbiter-core/src/datastructures/languages/MultiLanguageString";
import SingleLanguageString from "orbiter-core/src/datastructures/languages/SingleLanguageString";
import StaircasePlacementOption, {IStaircasePlacementOption} from "../../../../../shared/datastructures/staircasedata/StaircasePlacementOption";
import ApiController from "../ApiController";

export default class StaircasePlacementOptionAPI extends ApiController<StaircasePlacementOption> implements IStaircasePlacementOption {

    public static getBaseEndpoint(): string{
        return "hotec/staircaseplacementoption";
    }

    public static getApiKey(): string{
        return "staircasePlacementOption";
    }

    public async parseFromDictionary(dictionary): Promise<void> {

        const title = new MultiLanguageString(
            dictionary.title.map((x) => {
                // TODO: LanguageAPI?
                const l = new Language(
                    x.languageId,
                    null,
                    null,
                );
                return new SingleLanguageString(
                    l,
                    x.value,
                );
            }),
        );

        const desc = new MultiLanguageString(
            dictionary.description.map((x) => {
                // TODO: LanguageAPI?
                const l = new Language(
                    x.languageId,
                    null,
                    null,
                );
                return new SingleLanguageString(
                    l,
                    x.value,
                );
            }),
        );

        const t = new StaircasePlacementOption(
            dictionary.price,
            title,
            desc,
        );
        this.setData(t);
    }

    public getDescription(): MultiLanguageString {
        return this.getData().getDescription();
    }

    public getPrice(): number {
        return this.getData().getPrice();
    }

    public getTitle(): MultiLanguageString {
        return this.getData().getTitle();
    }

    public async setDescription(description: MultiLanguageString): Promise<void> {
        this.getData().setDescription(description);
        await this.updateProperty("description", description);
    }

    public async setPrice(price: number): Promise<void> {
        this.getData().setPrice(price);
        await this.updateProperty("price", price);
    }

    public async setTitle(title: MultiLanguageString): Promise<void> {
        this.getData().setTitle(title);
        await this.updateProperty("title", title);
    }

}